import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './TrustBanner.css';

const TrustBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="trust-banner">
      <div className="container trust-banner-content">
        <motion.h2
          className="trust-banner-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('trustBanner.title')}
        </motion.h2>
        
        <motion.p
          className="trust-banner-subtitle"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t('trustBanner.subtitle')}
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Link to="/portfolio" className="trust-banner-btn">
            {t('trustBanner.button')}
            <FiArrowRight />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBanner;
